import { Box, Icon, withStyles } from 'vopay';
import styles from './TicketsPage.module.scss';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/providers/Permissions.provider';
import { Button, Title } from 'UI';

const cn = withStyles(styles);

type NoSubmittedTicketsProps = {
  onCreateTicketClick: () => void;
};

export default function NoSubmittedTickets({ onCreateTicketClick }: NoSubmittedTicketsProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'TicketsList' });
  const { permissions } = usePermissions();

  return (
    <Box flx="col" className={cn('ticketListTableContainer')} width="100%" gap="common">
      <Box flx="col" jc="center" gap="sm">
        <Box ai="center" jc="center" height="auto">
          <Icon icon="photo" size="xxlg" color="greyLight" />
        </Box>

        <Box ai="center" jc="center" pt="md" height="auto">
          <Title level="3">{t('EmptyState.titleNoTickets')}</Title>
        </Box>

        <Box ai="center" jc="center" height="auto" className={cn('emptyListDescription')}>
          {t('EmptyState.descriptionNoTickets')}
        </Box>

        {permissions.CreateSupportTickets && (
          <Box ai="center" jc="center" pt="md" height="auto">
            <Button id="tickets-noTickets-addTicket" colorScheme="primary" size="large" onClick={onCreateTicketClick}>
              {t('submitTicketButton')}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
}
